__webpack_require__.p = "/search-assets/scripts/";